import geral from './geral.js'
import barbearia from './barbearia.js'
import salao from './salao.js'
import clinica from './clinica.js'

// Ordem = ordem de exibição no seletor de nicho do rodapé. "geral" (o padrão,
// exibido na home) fica de fora dessa lista — ele já é o que o usuário vê sem
// precisar clicar em nenhum link de segmento.
export const NICHE_LIST = [barbearia, salao, clinica]

const NICHE_BY_SLUG = Object.fromEntries([geral, ...NICHE_LIST].map((n) => [n.slug, n]))

const DEFAULT_SLUG = geral.slug

// A landing não tem roteador (uma página só, com âncoras — ver README), então
// o nicho ativo é lido da query string (`?nicho=salao-de-beleza`); trocar de
// nicho recarrega a página com esse parâmetro. Sem parâmetro (ou valor
// desconhecido), cai no nicho padrão (geral, para estabelecimentos de beleza
// em geral). Os nichos específicos (barbearia, salão, clínica) ficam
// acessíveis pelos links "Segmentos" do rodapé.
export function resolveNiche() {
  if (typeof window === 'undefined') return NICHE_BY_SLUG[DEFAULT_SLUG]
  const slug = new URLSearchParams(window.location.search).get('nicho')
  return NICHE_BY_SLUG[slug] || NICHE_BY_SLUG[DEFAULT_SLUG]
}

export function nicheHref(slug) {
  return slug === DEFAULT_SLUG ? '/' : `/?nicho=${slug}`
}
